import { FindRsyncResult } from "~/api/data/Admin/Rsync/FindRsyncResult";
export class RsyncListViewModel {
    constructor(model) {
        this.model = model;
    }
    model = new FindRsyncResult();
    get targetOperation() {
        return this.model.targetOperation;
    }
    get syncId() {
        return this.model.syncId;
    }
    get failureDate() {
        return this.model.failureDate;
    }
    get userCd() {
        return this.model.userCd;
    }
    get userName() {
        return this.model.userName;
    }
    get buknCd() {
        return this.model.buknCd;
    }
    get buknName() {
        return this.model.buknName;
    }
    get roomNo() {
        return this.model.roomNo;
    }
    get nyukyokeiyakuNo() {
        return this.model.nyukyokeiyakuNo;
    }
    get nyukyokeiyakuName() {
        return this.model.nyukyokeiyakuName;
    }
    get identifyCode() {
        return this.model.identifyCode;
    }
}
